import { secureInitParametersAtom } from '@onramp/state/recoil/atoms/secureInitAtoms';
import { clientSessionIdStore } from '@onramp/utils/clientSessionIdStore';
import { useInitParams } from '@onramp/v2/client/contexts/initParams/InitParamsContext';
import { useAtomValue } from 'jotai';

export function useAppId() {
  const {
    internalInitParams: {
      clientAppDetails: { appId: initParamsAppId },
    },
  } = useInitParams();
  const secureInitParameters = useAtomValue(secureInitParametersAtom);
  // Testing showed that clientSession and init params were missing app ID, but leaving them as a backup just in case
  const secureInitAppId = secureInitParameters?.appId;
  const clientSessionAppId = clientSessionIdStore.getClientAppDetails()?.appId;

  const appId = secureInitAppId ?? clientSessionAppId ?? initParamsAppId ?? '';

  return appId;
}
